import { css } from '@emotion/react';
import { useThemeValues } from '../../../hooks/use-theme-values';
import { styles } from '../../../styles';
import { Text } from '../../text/text.component';
import { TextLink } from '../../text-link/text-link.component';
import { ListFieldItemStyles } from './list-field-item.styles';

type Props = {
  children: React.ReactNode;
  disabled?: boolean;
  onRemove: () => void;
};

export const ListFieldItem = ({ children, disabled, onRemove }: Props) => {
  const style = ListFieldItemStyles.listFieldItem;
  const theme = useThemeValues();
  return (
    <li css={style}>
      <Text
        css={[
          css`
            margin: ${theme.spacing(0, 2, 0, 0)};
          `,
          styles.truncate,
        ]}
      >
        {children}
      </Text>
      {!disabled && <TextLink onClick={onRemove}>Remove</TextLink>}
    </li>
  );
};
